<div class="modal-header">
  <h4 class="modal-title"> {{'shareProjectLinkPopup.title' | translate}} </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p>{{'shareProjectLinkPopup.info' | translate:{'0': temporaryLinkValidDays} }}</p>
    <table class="w-100 pt-1">
      <colgroup>
        <col>
        <col width="145">
      </colgroup>
      <tbody>
        <tr>
          <td colspan="2">
            <p class="mb-2">
              <app-svg-icon type="share" [inline]="true"/> {{'shareProjectLinkPopup.temporary_link_label' | translate:{'0': temporaryLinkValidDays} }}
            </p>
          </td>
        </tr>
        <tr>
          <td class="align-top">
            <textarea class="form-control resize-none break-all pointer-events-auto" rows="3" spellcheck="false" [ngModel]="temporaryLink" [readonly]="true"></textarea>
          </td>
          <td class="align-top">
            <div class="ms-3">
              <button class="btn btn-primary h-100 w-100 ms-auto" (click)="copyTemporaryLink()" data-testid="copy-temporary-link">{{'shareProjectLinkPopup.copy_link' | translate}}</button>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <p class="mt-4 mb-2">
              <app-svg-icon type="share" [inline]="true"/> {{'shareProjectLinkPopup.html_link_label' | translate}}
            </p>
          </td>
        </tr>
        <tr>
          <td class="align-top">
            <div>
              <div class="form-check">
                <input type="radio" class="form-check-input" id="radio1" name="radioGroup" [value]="linkTypes[0]" [(ngModel)]="shareLinkType">
                <label class="form-check-label" for="radio1" [innerHTML]="'shareProjectLinkPopup.html_link_temporary' | translate"></label>
              </div>
              <div class="form-check mt-1">
                <input type="radio" class="form-check-input" id="radio2" name="radioGroup" [value]="linkTypes[1]" [(ngModel)]="shareLinkType">
                <label class="form-check-label" for="radio2" [innerHTML]="'shareProjectLinkPopup.html_link_permanent' | translate"></label>
              </div>
            </div>
          </td>
          <td class="align-top">
            <div class="ms-3">
              <button class="btn btn-primary h-100 w-100 ms-auto" (click)="generateProjectUrlHtmlFile()">{{'global.label.save' | translate}}</button>
            </div>
            <div *ngIf="isProjectSharingAvailable" class="ms-3 mt-3">
              <button class="btn btn-primary h-100 w-100 ms-auto" (click)="openPermissionDialog()">{{'shareProjectPopup.title' | translate}}</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
</div>
